import React from "react";

/**
 * The red asterisk beside a required field's label.
 *
 * `aria-hidden` on purpose: a screen reader should hear a field's required
 * state from the control, not the word "star" read out as part of the label.
 *
 * The colour is a raw palette class rather than the `status-error` /
 * `tone-rose` token, because nine sites already draw this asterisk by hand in
 * `text-red-500` — `RHFInput`, `RHFSelect`, `RHFDateInput`,
 * `RHFMonthYearPicker`, `ColorPicker`, `RHFNativeTimeInput`, `JobForm` and two
 * modals — and a lone themed red beside them reads as a second colour rather
 * than a correction. `.claude/rules/frontend-ux.md` wants the token; pointing
 * those nine here first makes that a one-line change for all of them at once.
 */
const RequiredMark = () => <span aria-hidden="true" className="text-red-500 font-bold text-[16px] ml-1">*</span>;

export default RequiredMark;
